module.exports = __webpack_public_path__ + "img/programme1.99c06db2.png";